import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { ImNotification } from "react-icons/im";
import Rsidebar from "../RSidebar/rsidebar";
import { handleAPIRequest } from "../../api/api";
import { useSelector } from "react-redux";

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
        const token = useSelector((state) => state.auth.token); 
    const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
    const [logs, setLogs] = useState([]);
    const getLogs = async() => {

        const response = await handleAPIRequest("get", "get-logs/", null, null, token);
        setLogs(response?.data?.logs);
    }
    useEffect(() => {
        getLogs();
    }
    , []);


    // const [logs] = useState([
    //     "User logged in at 10:00 AM",
    //     "Company deleted at 10:30 AM",
    //     "Subscription updated at 11:00 AM",
    // ]);
    
    return (
        <header className="bg-gray-800 text-white p-4 flex items-center justify-between md:px-6 md:py-4 relative h-12">
            {/* Left Sidebar Toggle (Hamburger Button) */}
            <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-white text-xl md:hidden">
                <FaBars />
            </button>

            {/* Centered Dashboard Heading */}
            <p className="text-xl font-bold absolute left-1/2 transform -translate-x-1/2">
                Dashboard
            </p>

            {/* Right Sidebar Toggle (Hamburger Button for Logs) */}
            <button 
                onClick={() => setIsRightSidebarOpen(!isRightSidebarOpen)} 
                className="text-white text-xl ml-auto"
            >
                <ImNotification />
            </button>

            {/* Right Sidebar Component */}
            <Rsidebar 
                isOpen={isRightSidebarOpen} 
                setIsOpen={setIsRightSidebarOpen} 
                logs={logs} 
            />
        </header>
    );
};

export default Navbar;
